import { render } from "./UserRole.vue?vue&type=template&id=2b9add29&scoped=true"
import script from "./UserRole.vue?vue&type=script&lang=js"
export * from "./UserRole.vue?vue&type=script&lang=js"

import "./UserRole.vue?vue&type=style&index=0&id=2b9add29&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b9add29"

export default script